/**
 * Timeframe helpers for Manual trade. Candle boundaries are never computed here: since spec 070 the
 * live view's frames (`isNew`, `closed`, bucket-close `time`) decide them.
 */
import type { CandlePoint } from './types'

export const TF_SECONDS: Record<string, number> = { '1m': 60, '5m': 300, '15m': 900, '1h': 3600, '4h': 14400 }
export const TIMEFRAMES = ['1m', '5m', '15m', '1h', '4h'] as const
export type Timeframe = (typeof TIMEFRAMES)[number]

/** Unknown/missing -> `5m`. */
export function parseTimeframe(value: string | null | undefined): Timeframe {
  return (TIMEFRAMES as readonly string[]).includes(value ?? '') ? (value as Timeframe) : '5m'
}

/** Bars in 24 h at this timeframe. */
export function lookbackBars(tfSeconds: number): number {
  return Math.round(86400 / tfSeconds)
}

/** Percent change of the last close against the close one day of bars earlier (clamped to the first bar). */
export function change24hPct(candles: CandlePoint[], tfSeconds: number): number | null {
  if (candles.length === 0) return null
  const last = candles[candles.length - 1]
  const from = candles[Math.max(0, candles.length - 1 - lookbackBars(tfSeconds))]
  return ((last.close - from.close) / from.close) * 100
}
